export const breakpoints = { xs: 0, mobile: 768, tablet: 1024 };
